export const CheckIcon = () => <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_19273_109896)">
        <path d="M9.37508 16.875L5.00008 12.5L3.54175 13.9584L9.37508 19.7917L21.8751 7.29171L20.4167 5.83337L9.37508 16.875Z" fill="#24D07B" />
    </g>
    <defs>
        <clipPath id="clip0_19273_109896">
            <rect width="25" height="25" rx="8" fill="white" />
        </clipPath>
    </defs>
</svg>
